<div class="side-nav scrollbar-wrapper" sideNav>


  <ul class="ant-menu ant-menu-root ant-menu-inline side-nav-menu"
      [ngClass]="{
            'ant-menu-inline-collapsed': isFolded,
            'ant-menu-dark' : isSideNavDark
        }">

    @for (item of menuItems; track item) {
      <li [ngClass]="item.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
        [routerLinkActive]="item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
        [routerLinkActiveOptions]="{exact: true}">
        @if (item.submenu.length > 0) {
          <a href="javascript:void(0);" class="ant-menu-submenu-title">
            @if (item.iconType == 'nzIcon') {
              <i nz-icon [nzType]="item.icon" [nzTheme]="item.iconTheme"></i>
            }
            @if (item.iconType == 'fontawesome') {
              <i class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
            }
            <span>{{ item.title | translate }}</span>
            <i class="ant-menu-submenu-arrow"></i>
          </a>
        }
        @if (!item.submenu.length > 0) {
          <a [routerLink]="item.path">
            @if (item.iconType == 'nzIcon') {
              <i nz-icon [nzType]="item.icon" [nzTheme]="item.iconTheme"></i>
            }
            @if (item.iconType == 'fontawesome') {
              <i class="m-r-10" [ngClass]="[item.iconTheme , item.icon]"></i>
            }
            <span>{{ item.title | translate }}</span>
          </a>
        }
        <!-- Second Level -->
        @if (item.submenu.length > 0) {
          <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu">
            @for (subItem of item.submenu; track subItem) {
              <li [ngClass]="subItem.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                [routerLinkActive]="subItem.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
                [routerLinkActiveOptions]="{exact: true}">
                @if (subItem.submenu.length > 0) {
                  <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50">
                    @if (subItem.iconType == 'nzIcon') {
                      <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i>
                    }
                    @if (subItem.iconType == 'fontawesome') {
                      <i class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                    }
                    <span>{{ subItem.title | translate }}</span>
                    <i class="ant-menu-submenu-arrow"></i>
                  </a>
                }
                @if (!subItem.submenu.length > 0) {
                  <a [routerLink]="subItem.path" class="p-l-30">
                    @if (subItem.iconType == 'nzIcon') {
                      <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i>
                    }
                    @if (subItem.iconType == 'fontawesome') {
                      <i class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                    }
                    <span>{{ subItem.title | translate }}</span>
                  </a>
                }
                <!-- Third Level -->
                @if (subItem.submenu.length > 0) {
                  <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu">
                    @for (subItem of subItem.submenu; track subItem) {
                      <li  [ngClass]="subItem.submenu.length > 0?'ant-menu-submenu ant-menu-submenu-inline':'ant-menu-item'"
                        routerLinkActive="ant-menu-item-selected"
                        [routerLinkActiveOptions]="{exact: true}">
                        @if (subItem.submenu.length > 0) {
                          <a href="javascript:void(0);" class="ant-menu-submenu-title p-l-50">
                            @if (subItem.iconType == 'nzIcon') {
                              <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i>
                            }
                            @if (subItem.iconType == 'fontawesome') {
                              <i class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                            }
                            <span>{{ subItem.title | translate }}</span>
                            <i class="ant-menu-submenu-arrow"></i>
                          </a>
                        }
                        @if (!subItem.submenu.length > 0) {
                          <a [routerLink]="subItem.path" class="p-l-50">
                            @if (subItem.iconType == 'nzIcon') {
                              <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i>
                            }
                            @if (subItem.iconType == 'fontawesome') {
                              <i class="m-r-10" [ngClass]="[subItem.iconTheme , subItem.icon]"></i>
                            }
                            <span>{{ subItem.title | translate }}</span>
                          </a>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>
